import { koComponent } from '../ko-utils';

class ImgEx {
    constructor(params) {
        this.imgId = params.imgId;
        this.url = ko.isObservable(params.url) ? params.url : ko.observable(params.url);

        this.antiCorsUrl = ko.pureComputed(() => {
            let url = ko.unwrap(this.url);
            if (url.startsWith('//')) {
                url = 'https:' + url;
            }
            return `https://cpxy.product-fruits.workers.dev/?${url}`;
        });

        this.width = params.width;
        this.height = params.height;

        this.canEdit = params.canEdit || ko.observable(true);

        if (ko.isObservable(this.url)) {
            this.url.subscribe(() => {
                this.imageHasError(false);
            });
        }

        this.imageHasError = ko.observable(false);
    }

    fileSelected(_, e) {
        const file = e.target.files[0];

        if (file) {
            if (!file.type.match('image.*')) {
                return; // todo: error
            }

            var reader = new FileReader();

            reader.onload = (e) => {
                this.url(e.target.result);
            };

            reader.readAsDataURL(file);
        }
    }

    onImgError() {
        this.imageHasError(true);

        this.removeImg();
    }

    removeImg() {
        try {
            this.url(null);
        } catch { }
    }
}

export default koComponent('img-ex', ImgEx);